import store from "../store"
import router from "../router"
import Permissions from "../consts/Permissions"

function accessToRoute(to) {
	let resolved = router.resolve(to).route

	//console.log(`Checking route access to route ${resolved.path}`)
	if (!resolved.matched.some((val)=>{return val.meta.requiresAuth === true})) {
		//console.log(`Page does not require authentication.`)
		return true
	}
	if (!store.getters["user/isLoggedIn"]) {
		//console.error("Not logged in")
		return false
	}
	let user = store.state.user.user
	if (!user) {
		//console.log(`User object did not exist`)
		return false
	}
	if (!!resolved.meta?.product && user.products && !user.products.includes(resolved.meta.product)) {
		//console.error(`No product access! Users products: ${JSON.stringify(user.products)}, required product: ${resolved.meta.product}. is included = ${user.products.includes(resolved.meta.product)}`)
		return false
	}
	let noAccess = resolved.matched.some((val)=>{
		let resource = val.meta.resource || Permissions.Resource.Portal
		let operation = val.meta.operation || "R"
		if (!resource) {
			return false
		}
		if (!accessToOperation(resource, operation)) {
			//console.error("No Permission")
			return true
		}
	})
	if (noAccess) {
		return false
	}
	return true
}

function accessToOperation(resource, operation) {
	let user = store.getters["user/getUser"]
	if (!user) {
		return false
	}

	//console.log(`Checking Operation Access ['${resource}' => '${operation}']`)
	let userPermissions = user.permissions
	let permissions = userPermissions[resource]
	if (!permissions) {
		return false
	}
	//console.log(`permissions['${operation}'] = ${permissions[operation]}`)
	if (permissions[operation] !== 1) {
		//console.log(`permissions['${operation}'] = ${permissions[operation]} = false`)
		return false
	}

	return true
}

export { accessToOperation, accessToRoute }